import { registerPageInit } from '../barba/page-init-registry';
import '../../css/_root.scss';
import '../../css/pages/politica/politica.scss';

class ReminderForResidents {
  constructor() {}

  public init(): void {
    this.bindEvents();
  }

  private bindEvents(): void {}
}

registerPageInit('reminder-for-residents', () => {
  const page = new ReminderForResidents();
  page.init();
});
